export const getRegexFromQuery = query => {
	let regexSearchPhase = '';
	const splittedQuery = escapeRegExp(query).split(' ');

	if (splittedQuery.length <= 1) { // only one word
		// eslint-disable-next-line prefer-destructuring
		regexSearchPhase = splittedQuery[0];
	}
	else {
		// eslint-disable-next-line guard-for-in
		for (const eachQueryPart in splittedQuery) {
			regexSearchPhase += `(?=.*${splittedQuery[eachQueryPart]})`;
		}
		regexSearchPhase += '.*';
	}

	return regexSearchPhase;
};

function escapeRegExp (text) {
	return text.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
